const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const defaultApiBaseUrl = process.env.NODE_ENV === "development" ? "http://localhost:3002" : "/api";
const rawApiBaseUrl = envApiBaseUrl || defaultApiBaseUrl;

export const API_BASE_URL = rawApiBaseUrl.replace(/\/+$/, "") || "/api";

export const buildApiUrl = (path = "") => {
  if (!path) return API_BASE_URL;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
